"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeIndexer = void 0;
const lodash_1 = __importDefault(require("lodash"));
class NodeIndexer {
    nodeIndices;
    startingIndex;
    delimiter;
    constructor(numberOfLevels, startingIndex, delimiter = '.') {
        this.nodeIndices = this.getInitialArrayByNumberOfLevels(numberOfLevels);
        this.startingIndex = startingIndex;
        this.delimiter = delimiter;
    }
    /** Retrieves the next index string
     *  @param {number} level - The level (starting at 1) for the desired index  */
    getNextIndex(level) {
        const currentIndexPosition = level - 1;
        this.updateIndices(currentIndexPosition);
        const parentIndexValues = this.getParentIndexValues(currentIndexPosition);
        return this.buildIndex(parentIndexValues, this.nodeIndices[currentIndexPosition]);
    }
    getInitialArrayByNumberOfLevels(numberOfLevels) {
        return new Array(numberOfLevels).fill(null);
    }
    getParentIndexValues(currentIndexPosition) {
        return lodash_1.default.take(this.nodeIndices, currentIndexPosition);
    }
    buildIndex(prefixIndexValues, currentIndexValue) {
        return prefixIndexValues.concat(currentIndexValue).filter(Boolean).join(this.delimiter);
    }
    resetChildrenIndices(currentIndexPosition) {
        for (let levelIndex = currentIndexPosition + 1; levelIndex < this.nodeIndices.length; levelIndex++) {
            this.nodeIndices[levelIndex] = null;
        }
    }
    updateIndices(currentIndexPosition) {
        const currentIndexValue = this.nodeIndices[currentIndexPosition];
        if (!currentIndexValue) {
            this.nodeIndices[currentIndexPosition] = this.startingIndex;
        }
        else {
            this.nodeIndices[currentIndexPosition] = currentIndexValue + 1;
            this.resetChildrenIndices(currentIndexPosition);
        }
    }
}
exports.NodeIndexer = NodeIndexer;
